import React from 'react';
import {Alert} from "reactstrap";

class NewUserModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            newMemberUsername: this.props && this.props.newMemberUsername,
            newMemberPassword: this.props && this.props.newMemberPassword
        }
    }

    // componentWillReceiveProps(nextProps) {
    //     if (this.props !== nextProps) {
    //         this.setState({ProvinceList: this.props.ProvinceList});
    //     }
    // }

    render() {
        return (
            <>
                <Alert color="danger">
                     بعد از بستن این
                    پنجره شما قادر به دیدن رمز عبور و نام كاربري نخواهید بود.
                </Alert>

                <div>
                    <h3>نام کاربری:</h3>
                    <p className="pl-4">{this.state.newMemberUsername}</p>

                    <h3>رمز عبور:</h3>
                    <p className="pl-4">{this.state.newMemberPassword}</p>
                </div>
            </>
        );
    }
}

export default NewUserModal;